import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useRef, useCallback, useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import Image from 'next/image';
import { debounce, TriggerManager } from '@@client/lib/util';
import { buildSearchUrl } from '@@client/parts/parts-helper';
import Loading from '@@client/components/Loading';
import Carousel, { PrevControl, NextControl, Indicators } from '@@client/components/Carousel';
import loadFeaturedPartTypeList from '@@client/parts/part-type/loadFeaturedPartTypeList';
import { getFallbackUrlByPartType } from '@@client/media/api';

var OneFeaturedPartType = function OneFeaturedPartType(_ref) {
  var partTypeInfo = _ref.partTypeInfo;
  var photoUrl = getFallbackUrlByPartType(partTypeInfo.partTypeNumber);
  var categoryUrl = buildSearchUrl({
    partTypeSlug: partTypeInfo.defaultSlug
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      href: categoryUrl,
      children: /*#__PURE__*/_jsxs("a", {
        className: "jsx-391126023" + " " + 'category',
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-391126023" + " " + 'photo',
          children: /*#__PURE__*/_jsx(Image, {
            layout: "fill",
            src: photoUrl,
            alt: partTypeInfo.defaultName
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-391126023" + " " + 'name',
          children: partTypeInfo.defaultName
        })]
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "391126023",
      children: [".category.jsx-391126023{display:block;position:relative;color:black;font-weight:700;-webkit-text-decoration:none;text-decoration:none;min-width:0;}", ".photo.jsx-391126023{height:110px;border:1px solid #CCD0E0;background:white;padding:20px;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;margin-bottom:10px;-webkit-transition:all 200ms ease;-webkit-transition:all 200ms ease;transition:all 200ms ease;position:relative;top:0;}", "@media(min-width:576px){.photo.jsx-391126023{height:200px;}}", "@media(min-width:768px){.photo.jsx-391126023{height:110px;}}", ".category.jsx-391126023:hover .photo.jsx-391126023{border-color:#65A0F4;-webkit-box-shadow:0 10px 13px 0 rgba(0,0,0,0.2);box-shadow:0 10px 13px 0 rgba(0,0,0,0.2);top:-3px;}", ".photo.jsx-391126023 img{max-height:100%;}", ".name.jsx-391126023{text-align:center;}"]
    })]
  });
};

var FeaturedPartTypes = function FeaturedPartTypes(_ref2) {
  var numSlides = _ref2.numSlides,
      partTypeStore = _ref2.partTypeStore,
      slideContainerRef = _ref2.slideContainerRef,
      onSlideChange = _ref2.onSlideChange,
      triggerSlideNext = _ref2.triggerSlideNext,
      triggerSlidePrev = _ref2.triggerSlidePrev,
      triggerSlideTo = _ref2.triggerSlideTo;
  if (partTypeStore.featuredList.doing) return /*#__PURE__*/_jsx(Loading, {});
  if (!partTypeStore.featuredList.entities.length) return /*#__PURE__*/_jsx("em", {
    children: "No categories found."
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Carousel, {
      label: "Popular Categories Slider",
      trackId: "home-popular-categories-track",
      slideContainerRef: slideContainerRef,
      numSlides: numSlides,
      onSlideChange: onSlideChange,
      renderIndicators: false,
      renderNextPrevControls: false,
      triggerSlideNext: triggerSlideNext,
      triggerSlidePrev: triggerSlidePrev,
      triggerSlideTo: triggerSlideTo,
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-1442184423" + " " + 'categories',
        children: /*#__PURE__*/_jsx("div", {
          ref: slideContainerRef,
          className: "jsx-1442184423" + " " + 'inner',
          children: partTypeStore.featuredList.entities.map(function (x) {
            return /*#__PURE__*/_jsx(OneFeaturedPartType, {
              partTypeInfo: x
            }, x.id);
          })
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1442184423",
      children: [".categories.jsx-1442184423{--numColumns:2;--gapWidth:20px;padding-left:10px;overflow-x:hidden;}", "@media(min-width:768px){.categories.jsx-1442184423{--numColumns:3;}}", "@media(min-width:992px){.categories.jsx-1442184423{--numColumns:4;}}", "@media(min-width:1200px){.categories.jsx-1442184423{--numColumns:5;}}", ".inner.jsx-1442184423{position:relative;-webkit-transition:left 500ms ease,height 500ms ease;-webkit-transition:left 500ms ease,height 500ms ease;transition:left 500ms ease,height 500ms ease;left:0;display:grid;grid-auto-flow:column;grid-auto-columns:calc(100%/var(--numColumns) - var(--gapWidth));grid-template-rows:repeat(2,1fr);grid-column-gap:var(--gapWidth);grid-row-gap:var(--gapWidth);padding-top:3px;}"]
    })]
  });
};

export default connect(function (_ref3) {
  var partType = _ref3.parts.partType;
  return {
    partTypeStore: partType
  };
}, function () {
  return {};
})(function (_ref4) {
  var title = _ref4.title,
      description = _ref4.description,
      partTypeStore = _ref4.partTypeStore;
  loadFeaturedPartTypeList();
  var slideContainerRef = useRef(null);

  var _useState = useState(1),
      numSlides = _useState[0],
      setNumSlides = _useState[1];

  var _useState2 = useState(1),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  var _useState3 = useState(null),
      carouselControlsId = _useState3[0],
      setCarouselControlsId = _useState3[1];

  var getNumSlides = useCallback(function () {
    var defaultNumColumns = 1; // this is for browsers that don't support CSS variables (IE11)

    if (slideContainerRef !== null && slideContainerRef !== void 0 && slideContainerRef.current) {
      var numChildren = partTypeStore.featuredList.entities.length;
      if (!numChildren) return 1;
      var numColumns = getComputedStyle(slideContainerRef.current).getPropertyValue('--numColumns') || defaultNumColumns;
      var numRows = 2;
      var itemsPerPage = numColumns * numRows;
      return Math.ceil(numChildren / itemsPerPage);
    }

    return 1; // default
  }, [partTypeStore.featuredList.entities.length]); // need to do this in useEffect because we access `--numColumns` from the DOM and it needs to exist first

  useEffect(function () {
    setNumSlides(getNumSlides());
  }, [partTypeStore.featuredList.entities.length]); // the number of columns changes on resize, so potentially need to re-render

  useEffect(function () {
    var handleResize = debounce(function () {
      setNumSlides(getNumSlides());
    }, 500);

    var on = function on() {
      return window.addEventListener('resize', handleResize);
    };

    var off = function off() {
      return window.removeEventListener('resize', handleResize);
    };

    on();
    return off;
  }, [partTypeStore.featuredList.entities.length]);
  var onSlideChange = useCallback(function (_ref5) {
    var currentSlide = _ref5.currentSlide,
        controls = _ref5.controls;
    setCurrentSlide(currentSlide);
    setCarouselControlsId(controls);
  }, []);

  var renderControls = function renderControls() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrevControl, {
        onClick: slidePrevTriggerManager.trigger,
        controls: carouselControlsId
      }), /*#__PURE__*/_jsx(Indicators, {
        onClick: slideToTriggerManager.trigger,
        controls: carouselControlsId,
        num: numSlides,
        currentSlide: currentSlide
      }), /*#__PURE__*/_jsx(NextControl, {
        onClick: slideNextTriggerManager.trigger,
        controls: carouselControlsId
      })]
    });
  }; // this is used to pass events to the Carousel, so can control slide transitions from here


  var slideNextTriggerManager = useMemo(TriggerManager, []);
  var slidePrevTriggerManager = useMemo(TriggerManager, []);
  var slideToTriggerManager = useMemo(TriggerManager, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-20871822" + " " + 'container a-sm',
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-20871822" + " " + 'grid',
        children: /*#__PURE__*/_jsxs("div", {
          className: "jsx-20871822" + " " + 'row',
          children: [/*#__PURE__*/_jsxs("div", {
            className: "jsx-20871822" + " " + 'col-md20',
            children: [/*#__PURE__*/_jsx("h2", {
              className: "jsx-20871822" + " " + 'h--md--blue',
              children: title
            }), /*#__PURE__*/_jsx("p", {
              className: "jsx-20871822",
              children: description
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-20871822" + " " + 'the-controls a-lg',
              children: renderControls()
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-20871822" + " " + 'col-md80',
            children: [/*#__PURE__*/_jsx(FeaturedPartTypes, {
              slideContainerRef: slideContainerRef,
              numSlides: numSlides,
              partTypeStore: partTypeStore,
              onSlideChange: onSlideChange,
              triggerSlideNext: slideNextTriggerManager.setCallback,
              triggerSlidePrev: slidePrevTriggerManager.setCallback,
              triggerSlideTo: slideToTriggerManager.setCallback
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-20871822" + " " + 'the-controls t-md',
              children: renderControls()
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "20871822",
      children: [".container.jsx-20871822{position:relative;margin-bottom:30px;}", "@media(max-width:575px){.container.jsx-20871822{margin-bottom:17px;}}", ".container.jsx-20871822 .the-controls.jsx-20871822{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:20px;}", "@media(min-width:992px){.container.jsx-20871822 .the-controls.jsx-20871822{-webkit-box-pack:start;-ms-flex-pack:start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;margi-top:0;}}", ".container.jsx-20871822 .the-controls.jsx-20871822 .control-prev:after,.container.jsx-20871822 .the-controls.jsx-20871822 .control-next:after{width:7px;height:7px;border-color:#21409A;}", ".container.jsx-20871822 .the-controls.jsx-20871822 .control-prev:hover:after,.container.jsx-20871822 .the-controls.jsx-20871822 .control-next:hover:after{border-color:#468EE5;}", ".container.jsx-20871822 .the-controls.jsx-20871822 .indicators{margin:0 6px;}", "@media(min-width:992px){.container.jsx-20871822 .the-controls.jsx-20871822 .indicator{padding:7px;}}"]
    })]
  });
});